export default __webpack_public_path__ + "static/media/rtWaitingIcon.9679b9c8.webp";